<template>
  <!-- 種別 -->
  <td
    class="text-center align-middle text-nowrap p-0 h-100 px-0"
    :class="schedule.statusClass.typeClass"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <div class="position-relative w-100 h-100 border border-5 border-white">
      <div class="position-absolute top-50 start-50 translate-middle">
        <a :href="schedule.routes.scheduleEdit">{{ schedule.type.name }}</a>
      </div>
    </div>
  </td>
  <!-- ./種別 -->

  <!-- 担当者 -->
  <td
    class="text-center align-middle a-deco text-nowrap user_cell px-0"
    @click="showSheduleUserEditModal(schedule.users, schedule.id)"
  >
    <span v-for="(user, key) in schedule.users" :key="key">
      <br v-if="key > 0 && key <= 1" />
      <a v-if="user.id && key <= 1" class="user_link">
        {{ user.displayName }}
      </a>
      <span v-if="key == 2">...</span>
    </span>
    <span class="m-0 p-0" v-if="schedule.users.length == 0">
      <LabelUnset></LabelUnset>
    </span>
  </td>
  <!-- ./担当者 -->

  <!-- 時間 -->
  <td
    class="text-center align-middle px-0"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <span v-if="schedule.strDate">{{ schedule.strDate }}</span>
    <LabelUnset v-else></LabelUnset>
  </td>
  <!-- ./時間 -->

  <!-- 車種 -->
  <td
    class="align-middle a-deco"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <a
      v-if="schedule.car && (schedule.car.carNumber && schedule.car.carModel.name)"
      :href="schedule.car.showRoute"
      @click.stop=""
    >
      <div class="fs-small lh-sm">{{ schedule.car.carNumber }}</div>
      {{ schedule.car.carModel.name }}
    </a>
    <LabelUnset v-else></LabelUnset>
  </td>
  <!-- ./車種 -->

  <!-- 協力店 -->
  <td
    class="text-center align-middle px-0"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <span v-if="schedule.cooperatingStoreName">
      {{ schedule.cooperatingStoreName }}
    </span>
    <LabelUnset v-else></LabelUnset>
  </td>
  <!-- ./協力店 -->

  <!-- 配送先 -->
  <td
    class="text-center align-middle px-0"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <span v-if="schedule.deliveryAddress">
      <a
        target="_blank"
        rel="noopener noreferrer"
        :href="schedule.googleMapPosition"
        v-if="schedule.googleMapPosition"
        @click.stop=""
      >
        <img src="/images/location-map-pin.png" width="20" height="20" />
      </a>
      {{ schedule.deliveryAddress }}
    </span>
    <LabelUnset v-else></LabelUnset>
  </td>
  <!-- ./配送先 -->

  <!-- 備考 -->
  <td
    class="text-center align-middle"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
  >
    <span
      class="ma-0 pa-0 text-nowrap"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      :title="schedule.comment"
      v-if="schedule.commentAbbreviation"
    >
      {{ schedule.commentAbbreviation }}
    </span>
    <span class="ma-0 pa-0 text-nowrap" v-else>{{ schedule.comment }}</span>
  </td>
  <!-- ./備考 -->

  <!-- 更新 -->
  <td
    class="text-center align-middle"
    @click="redirectScheduleEdit(schedule.routes.scheduleEdit)"
    v-if="!isMobile"
  >
    {{ schedule.updatedAt }}
    <div
      class="
        row
        g-0
        justify-content-center
        align-items-center
        fs-small
        lh-sm
        mt-1
      "
    >
      <div
        class="
          col-10 col-xxl-auto
          border border-g03
          bg-g03
          text-white
          px-2
          py-1
          text-nowrap
        "
      >
        更新者
      </div>
      <div
        class="
          col-10 col-xxl-auto
          border border-g03
          bg-white
          px-2
          py-1
          text-nowrap
        "
      >
        {{ schedule.createdUser.displayName }}
      </div>
    </div>
  </td>
  <!-- ./更新 -->

  <!-- Action -->
  <Action :schedule="schedule"></Action>
  <!-- ./Action -->
</template>

<script lang="ts">
/* Import Modules */
import { defineComponent, onMounted } from "vue";
import { Tooltip } from "bootstrap";
/* Import Compoments. */
import LabelUnset from "../../../../components/label/labelUnset.vue";
import Action from "./cell/action.vue";
/* Import Scripts. */
import { redirectScheduleEdit } from "../../../../compositions/script/pageRedirect";
import { showSheduleUserEditModal } from "../../../../compositions/scheduleUser/scheduleUserEditForm";

/* Import Variables */
export default defineComponent({
  components: {
    LabelUnset,
    Action,
  },
  props: {
    schedule: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    isMobile: {
      type: Boolean,
      required: false,
      default() {
        return false;
      },
    },
  },
  setup(props: { schedule: any; isMobile: Boolean }) {
    const schedule = props.schedule;
    const isMobile = props.isMobile;

    onMounted(() => {
      let tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      let tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
      });
    });
    return {
      /* valiables */
      schedule,
      isMobile,
      /* script */
      redirectScheduleEdit,
      showSheduleUserEditModal,
    };
  },
});
</script>
